import { Stack } from '@mui/material';

import { Mask, SummaryCardNew } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { CoparticipationPreviewSummaryProps } from '@services/FinancialService';

import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';

import { StackContainer, StackItem } from './styles';
import { SummaryItemProps } from './components/SummaryItem/types';
import { SummaryItem } from './components/SummaryItem';

export function CoparticipationPreviewReportSummary({
  totalValue,
  beneficiariesCount,
  proceduresCount,
}: CoparticipationPreviewSummaryProps) {
  const { isDesktop } = useDeviceBreakpoints();

  const summaryItems: SummaryItemProps[] = [
    {
      iconName: 'actions-b2b-attach-money',
      bgColor: NEW_COLORS.SEMANTICS.SUCCESS[50],
      iconColor: NEW_COLORS.SEMANTICS.SUCCESS[500],
      value: Mask.currency(totalValue ?? 0),
      label: 'Total a ser pago',
      textColor: NEW_COLORS.SEMANTICS.SUCCESS[500],
      marginBottom: 2,
    },
    {
      iconName: 'actions-b2b-account-box',
      bgColor: NEW_COLORS.SUPPORT.INDIGO[50],
      iconColor: NEW_COLORS.SUPPORT.INDIGO[500],
      value: String(beneficiariesCount ?? 0),
      label: 'Total de beneficiários',
      textColor: NEW_COLORS.SUPPORT.INDIGO[500],
      marginBottom: 2,
    },
    {
      iconName: 'medical-b2b-admin-meds',
      bgColor: NEW_COLORS.SUPPORT.PURPLE[50],
      iconColor: NEW_COLORS.SUPPORT.PURPLE[500],
      value: String(proceduresCount ?? 0),
      label: 'Total de procedimentos',
      textColor: NEW_COLORS.SUPPORT.PURPLE[500],
      marginBottom: 2,
    },
  ];

  const renderItems = () =>
    summaryItems.map(
      ({ iconName, label, value, bgColor, iconColor, textColor }) =>
        isDesktop ? (
          <SummaryItem
            key={label}
            iconName={iconName}
            label={label}
            value={value}
            bgColor={bgColor}
            iconColor={iconColor}
            textColor={textColor}
            marginBottom={2}
          />
        ) : (
          <StackItem key={label} flexDirection="column">
            <SummaryItem
              iconName={iconName}
              label={label}
              value={value}
              bgColor={bgColor}
              iconColor={iconColor}
              textColor={textColor}
              marginBottom={2}
            />
          </StackItem>
        ),
    );

  return isDesktop ? (
    <SummaryCardNew.Container>
      <SummaryCardNew.Header title="Resumo" />
      <Stack width="100%" direction="row" gap={3} sx={{ overflowX: 'auto' }}>
        {renderItems()}
      </Stack>
    </SummaryCardNew.Container>
  ) : (
    <StackContainer direction="row" gap={2}>
      {renderItems()}
    </StackContainer>
  );
}
